<template>
  <div
    class="cb_checkout_success pay-theme-layout--custom-blue"
    :class="{ 'cb_checkout_success--computer': isComputerLayout }"
  >
    <div class="cb_checkout_success_inner">
      <div class="cb_checkout_success_header">
        <img
          class="cb_checkout_success_logo"
          :src="logoUrl"
          alt=""
        />
      </div>

      <div class="cb_checkout_success_body">
        <h1 class="cb_checkout_success_title">{{ checkoutSuccessTitle }}</h1>
        <p class="cb_checkout_success_subtitle">{{ checkoutSuccessSubtitle }}</p>

        <img
          class="cb_checkout_success_illustration"
          src="@/assets/custom-blue/success-clipboard.png"
          alt=""
        />

        <div class="cb_checkout_success_card">
          <div class="cb_checkout_success_card_top">
            <div class="cb_checkout_success_card_top_label">{{ checkoutAmountLabel }}</div>
            <div class="cb_checkout_success_card_top_value">
              <span>{{ currencyCode }}</span>{{ displayAmount }}
            </div>
          </div>
          <div class="cb_checkout_success_card_bottom">
            <div class="cb_checkout_success_row">
              <span class="cb_checkout_success_row_label">{{ checkoutPayeePrefix }}</span>
              <span class="cb_checkout_success_row_value">{{ payeeName }}</span>
            </div>
            <div class="cb_checkout_success_row">
              <span class="cb_checkout_success_row_label">{{ checkoutWalletLabel }}</span>
              <span class="cb_checkout_success_row_value">{{ walletAccount }}</span>
            </div>
            <div class="cb_checkout_success_row">
              <span class="cb_checkout_success_row_label">{{ checkoutSuccessStatusLabel }}</span>
              <span class="cb_checkout_success_row_value cb_checkout_success_row_value--success">
                {{ checkoutSuccessStatusValue }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import themeMixin from '@/mixins/theme';

export default {
  name: 'CustomBlueCheckoutSuccess',
  mixins: [themeMixin],
  props: {
    repaymentData: {
      type: Object,
      default: () => ({}),
    },
    collectionData: {
      type: Object,
      default: () => ({}),
    },
    countryInfo: {
      type: Object,
      default: () => ({}),
    },
    countryInfoLogo: {
      type: String,
      default: '',
    },
    formatBankName: {
      type: Function,
      required: true,
    },
    layout: {
      type: String,
      default: 'moblie',
      validator: (value) => ['moblie', 'computer'].includes(value),
    },
  },
  computed: {
    isComputerLayout() {
      return this.layout === 'computer';
    },
    logoUrl() {
      return (
        this.repaymentData?.configData?.logoFileUrl ||
        this.countryInfoLogo ||
        this.themeImg('logo') ||
        ''
      );
    },
    currencyCode() {
      return this.countryInfo?.currencyCode || '';
    },
    displayAmount() {
      const collected = this.collectionData?.collectedAmount;
      if (collected != null && collected !== 0 && collected !== '0') {
        return collected;
      }
      return this.repaymentData?.cardData?.amount || '';
    },
    payeeName() {
      const bankName = this.repaymentData?.cardData?.bankName;
      return bankName ? this.formatBankName(bankName) : '—';
    },
    walletAccount() {
      return this.repaymentData?.cardData?.userSubmitAccountNumber || '—';
    },
  },
};
</script>
